import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.bind";
import _classCallCheck from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, createElement } from 'react';
import LaTeX2JS from 'latex2js';
import { getMathJax, loadMathJax } from 'latex2js-mathjax';
import pspicture from './components/pspicture';
import nicebox from './components/nicebox';
import enumerate from './components/enumerate';
import verbatim from './components/verbatim';
import slider from './components/slider';
import math from './components/math';
import macros from './components/macros';
var ELEMENTS = {
  pspicture: pspicture,
  nicebox: nicebox,
  enumerate: enumerate,
  verbatim: verbatim,
  math: math,
  macros: macros
};
export { pspicture, nicebox, enumerate, verbatim, math, macros };
export var LaTeX =
/*#__PURE__*/
function (_Component) {
  _inherits(LaTeX, _Component);

  function LaTeX(props) {
    var _this;

    _classCallCheck(this, LaTeX);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LaTeX).call(this, props));
    _this.onLoad = _this.onLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LaTeX, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (getMathJax()) {
        this.onLoad();
      }

      loadMathJax(this.onLoad);
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      this.setState({
        loaded: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!getMathJax()) return (
        /*#__PURE__*/
        React.createElement("div", {
          className: "latex-container"
        }, "loading...")
      );
      var latex = new LaTeX2JS();
      var parsed = latex.parse(this.props.content);
      var children = [];
      parsed && parsed.forEach && parsed.forEach(function (el) {
        if (ELEMENTS.hasOwnProperty(el.type)) {
          children.push(
          /*#__PURE__*/
          createElement(ELEMENTS[el.type], el));
        }
      });
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: "latex-container"
        }, children)
      );
    }
  }]);

  return LaTeX;
}(Component);